(function() { window.GUID_14c3850e_78b4_4691_8afd_7a8593e40dad = { getGuid: function() { return "14c3850e-78b4-4691-8afd-7a8593e40dad"; } }; })();
//function LoadFile(fileType, filePath, callback) {
//    var scriptTag = document.createElement(fileType);
//    scriptTag.onload = function (loadEvent) {
//        if (callback != null) {
//            callback.call(this);
//        }
//    };
//    scriptTag.type = "text/javascript";
//    (<any>scriptTag).src = filePath + "?forcedownload=" + new Date().getTime();
//    document.getElementsByTagName("head")[0].appendChild(scriptTag);
//}

//# sourceMappingURL=cs.dynamicfile.js.map
